import { Observable } from "rxjs";

export interface LookupConfiguration<T> {
    suggest: (term: string, limit?: number) => Observable<T[]>;
    lookup: (id: string) => Observable<T>;
    display: (item: T) => string;
    identifier: (item: T) => string;
}